export const fileInputAcceptances = {
  ONLY_IMAGES: 'image/png, image/jpeg',
}
